import { useParams } from 'react-router-dom';
import useCustomer from 'data/firestore/agent/customer/use';

const useInvoiceCustomerPhone = (customerId?: string) => {
    const { agentId = '' } = useParams();
    const disabled = !agentId || !customerId;
    const { data, error } = useCustomer(agentId, customerId || '', { disabled });
    const phone = data?.phoneNumber?.trim() || '';

    return {
        customer: data,
        phone,
        hasPhone: Boolean(phone),
        isPending: !disabled && !data && !error,
    };
};

export default useInvoiceCustomerPhone;
